import React from 'react';
import { cn } from '../../utils/cn';

export const Progress = ({ value = 0, className, ...props }) => {
  return (
    <div
      className={cn(
        'relative h-2 w-full overflow-hidden rounded-full bg-secondary',
        className,
      )}
      {...props}
    >
      <div
        className="h-full w-full flex-1 bg-primary transition-all"
        style={{
          transform: `translateX(-${100 - Math.min(Math.max(value, 0), 100)}%)`,
        }}
      />
    </div>
  );
};